var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 94,
    viewBox: "0 0 86 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-copy",
    transform: "translate(-5.21 -0.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M56.21,27.806h-44a7.008,7.008,0,0,0-7,7v53a7.008,7.008,0,0,0,7,7h44a7.009,7.009,0,0,0,7-7v-53A7.008,7.008,0,0,0,56.21,27.806Zm-1,59h-42v-51h42Zm-14-64.228h-8V14.806h8Zm0-13.772h-8a8.009,8.009,0,0,1,8-8Zm18,0h-12v-8h12Zm6-8h12v8h-12Zm26,8-8-.005V.806A8.009,8.009,0,0,1,91.21,8.806Zm-8,6h8v9h-8Zm0,15h8v9h-8Zm0,15h8v9h-8Zm0,15h8a8.009,8.009,0,0,1-8,8Zm-13.911,0H77.21v8H69.3Z",
    fill: "#0071b9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.da6301072607ee2711645e89b69a265d.svg";
export { ForwardRef as ReactComponent };